import {Injectable} from "@angular/core";

@Injectable()
export class JobControlsService {

  buttons = {
    hasVideoCall: (job, role) => job.type === 'video' && job.isAssigned() && !job.isEditable() && !job.isNew(),
    hasPreview: (job, role) => job.isEditable() && role === 'organisation',
    hasSave: (job, role) => job.canBeSaved() && !job.isEditable() && role === 'organisation',
    hasAccept: (job, role) => job.canBeAccepted() && role === 'interpreter',
    hasReject: (job, role) => job.canBeRejected() && role === 'interpreter',
  };

  hasButtons(job, role){
    for(let methodName in this.buttons){
      if(job && role && this.buttons[methodName](job, role)){
        return true;
      }
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/job/job-controls/job-controls.service.ts